<div
    class="agpr-inplace-container"
    [ngClass]="{'agpr-inplace-container--social' : style === agprComponentStyle.social}"
>
    <div
        *ngIf="!isEditing"
        class="agpr-inplace-label"
        (agprClickUnless)="edit()"
    >
        <label
            [pTooltip]="value"
            [tooltipPosition]="tooltipPosition"
        >
            {{ value }}
        </label>
        <button
            [id]="id + '_editButton'"
            *ngIf="!readonly"
            class="fa-regular fa-duotone fa-pen"
            [agprTooltip]="'Social.agentWidget.name.edit'"
            tooltipPosition="top"
        ></button>
    </div>

    <ng-container
        *ngIf="isEditing"
    >
        <agpr-text-input
            ariaLabel="Social.agentWidget.title.edit"
            [bottomMargin]="false"
            [initialFocus]="true"
            [maxLength]="maxLength"
            [(ngModel)]="tempValue"
            (blur)="applyChanges()"
            (keydown)="keyDown($event)"
            [initialHighlight]="true"
            [ariaDescribedBy]="ariaDescribedBy"
            [ariaInvalid]="ariaInvalid"
        ></agpr-text-input>
        <agpr-button
            icon="fa-regular fa-duotone fa-circle-check"
            [style]="buttonTypes.link"
            tooltip="Common.forms.inplace.tooltip.applyChange"
            tooltipPosition="top"
            (click)="applyChanges()"
        >

        </agpr-button>
        <agpr-button
            icon="fa-regular fa-duotone fa-circle-xmark"
            [style]="buttonTypes.link"
            tooltip="Common.forms.inplace.tooltip.revertChange"
            tooltipPosition="top"
            (click)="isEditing=false"
        >
        </agpr-button>
    </ng-container>
</div>


